if (!customElements.get('card-media-carousel')) {
  class CardMediaCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.card-carousel__track');
      if (!this.track) return;

      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      this.querySelectorAll('.card-carousel__arrow').forEach((arrow) => {
        arrow.addEventListener('click', this.onArrowClick.bind(this));
      });
    }

    onScroll() {
      const width = this.track.clientWidth;
      if (!width) return;
      this.style.setProperty('--slide-index', this.track.scrollLeft / width);
    }

    onArrowClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const direction = event.currentTarget.dataset.direction === 'next' ? 1 : -1;
      const width = this.track.clientWidth;
      const maxScroll = this.track.scrollWidth - width;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      let target = this.track.scrollLeft + direction * width;
      if (direction === 1 && this.track.scrollLeft >= maxScroll - 1) {
        target = 0; // wrap: last -> first
      } else if (direction === -1 && this.track.scrollLeft <= 1) {
        target = maxScroll; // wrap: first -> last
      }
      this.track.scrollTo({ left: target, behavior });
    }

    resetToFirst() {
      this.track.scrollTo({ left: 0, behavior: 'auto' });
    }
  }

  customElements.define('card-media-carousel', CardMediaCarousel);
}
